module.exports = __webpack_public_path__ + "img/DetailsImg.9c86df75.png";